module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/rooster.e6ff9660.jpg";